const accountSetRoute = [
  {
    path: "/personaldata",
    name: "PersonalData",
    component: () => import("@/views/accountSet/personalData/index.vue"),
    redirect: "/personaldata/personalinfo",
    children: [
      {
        path: "personalinfo",
        name: "PersonalInfo",
        component: () =>
          import("@/views/accountSet/personalData/personalInfo.vue"),
        meta: {
          activeName: "PersonalData",
        },
      },
      {
        path: "editproject",
        name: "EditProject",
        component: () =>
          import("@/views/accountSet/personalData/editProject.vue"),
        meta: {
          activeName: "PersonalData",
        },
      },
    ],
  },
  {
    path: "/passwordauth",
    name: "PasswordAuth",
    component: () => import("@/views/accountSet/passwordAuth/index.vue"),
    meta: {
      activeName: "PasswordAuth",
    },
  },
  {
    path: "/passwordmodify",
    name: "PasswordModify",
    component: () => import("@/views/accountSet/passwordModify/index.vue"),
    meta: {
      activeName: "PasswordModify",
    },
  },
  {
    path: "/accountbind",
    name: "AccountBind",
    component: () => import("@/views/accountSet/accountBind/index.vue"),
    meta: {
      activeName: "AccountBind",
    },
  },
];

export default accountSetRoute;
